import React from 'react'

export default function SeeMoreIcon({ className }) {
  return (
    <svg viewBox="0 0 12 12" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M-4.5897e-07 6C-4.95181e-07 5.58579 0.335786 5.25 0.749999 5.25L9.43934 5.25L6.21967 2.03033C5.92678
            1.73744 5.92678 1.26256 6.21967 0.969669C6.51256 0.676775 6.98744 0.676775 7.28033 0.969669L11.7803
            5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232
            6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335786 6.75
            -4.22758e-07 6.41421 -4.5897e-07 6Z"
            fill="currentColor"/>
    </svg>
  )
}
